import type { Components, Theme as MuiTheme } from '@mui/material';

export const breadcrumbsTheme: Components<MuiTheme> = {
  MuiBreadcrumbs: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: theme.spacing(1),
      }),
    },
  },
};
